import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from '../components/HomePage';
import LoginPage from '../components/LoginPage';
import RegistrationPage from '../components/RegistrationPage';
import ChangePasswordPage from '../components/ChangePasswordPage';
import ForgotPasswordPage from '../components/ForgotPasswordPage';
import ResetPasswordPage from '../components/ResetPasswordPage';
import CorruptionDeclarationPage from '../components/CorruptionDeclarationPage';
import TermsConditions from '../components/TermsConditions';
import TermsConditionsView from '../components/TermsConditionsView';
import LocationPage from '../components/LocationPage';
import ApplicationFormPage from '../components/ApplicationFormPage';
import DashboardRouteHandler from '../components/DashboardRouteHandler';
import AuthInfo from '../components/AuthInfo';
import AuthDebug from '../components/AuthDebug';
import PaymentPage from '../pages/Medical/PaymentPage';
import TestingPaymentPage from '../pages/Testing/PaymentPage';
import CalibrationPaymentPage from '../pages/Calibration/PaymentPage';
import AssessmentPaymentPage from '../pages/Assessment/PaymentPage';
import AssessmentPaymentResponsePage from '../pages/Assessment/PaymentResponsePage';
import PreviewReportassessment from '../components/PreviewReportAssessment';
import PreviewReportAssessmentCalibration from '../components/PreviewReportAssessmentCalibration';
import PreviewReportAssessmentTesting from '../components/PreviewReportAssessmentTesting';
import LabAdvisoryReply from '../components/LabAdvisoryReply';
import LabShowCauseReply from '../components/LabShowCauseReply';
import ViewCertificate from '../components/certificate/ViewCertificate';
import DownloadSymbol from '../components/certificate/DownloadSymbol';
import ILACMarkDownload from '../components/certificate/ILACMarkDownload';
import ACProcess from '../components/ACProcess';
import ScopeMasterPage from '../components/ScopeMasterPage';
import EquipmentMasterPage from '../components/EquipmentMasterPage';
import ChangeName from '../components/AddOnApplication/ChangeName';
import AcquisitionMerger from '../components/AddOnApplication/AcquisitionMerger';
import ChangeINCabPermises from '../components/AddOnApplication/ChangeINCabPermises';
import ILACPage from '../components/AddOnApplication/ILACPage';
import ViewNAF6 from '../components/ViewNAF6';

// Import Calibration Layout and Components
import WebAssessmentLayout from '../pages/webAssessment/layout';
// Import Medical Layout
import MedicalLayout from '../pages/Medical/layout';
import MedicalPDFViewer from '../components/PDFViewer/MedicalPDFViewer';
import PreviewReport from '../components/PreviewReport';
import PreviewReportAdditional from '../components/PreviewReportAdditionalApp/PreviewReportAdditional';
import PreviewReportPPPFFL from '../components/PreviewReportPPPFFL';
import TestingPreviewReport from '../components/TestingPreviewReport';
import CalibrationPreviewReport from '../components/CalibrationPreviewReport';
import PreviewReport7t from '../components/PreviewReport7t';
import PaymentResponsePage from '../pages/Medical/PaymentResponsePage';
import TestingLayout from '../pages/Testing/layout';
import CalibrationLayout from '../pages/Calibration/layout';
import ChooseAssessmentDate from '../components/ChooseAssessmentDate';
import AssessmentDetailsPage from '../components/AssessmentDetailsPage';
import LaboratoryUpdateDetailsPage from '../components/LaboratoryUpdateDetailsPage';
import Feedback from '../components/Feedback';
import AssessorProfilePage from '../components/AssessorProfile';
import AcceptAssessors from '../pages/CAB/AcceptAssessors';
import AssessorLogisticsAgreement from '../pages/CAB/AssessorLogisticsAgreement';
import DoLayout from '../pages/Do/layout';
import AdminLayout from '../pages/Admin/layout';
import ViewLayout from '../pages/viewAdmin/layout';
import SuperAdminLayout from '../pages/SuperAdmin/layout';
import AssessorLayout from '../pages/NAssessor/layout';
import JDLayout from '../pages/JD/layout';
import AccountsLayout from '../pages/Accounts/layout';
import AssessorDetailsView from '../pages/JD/application/AssessorDetailsView';
import AdditionalDocumentsPage from '../pages/AdditionalDocumentsWrapper';
import AssessorManagement from '../pages/AssessorManagement/AssessorManagement';
import ScopeDetailsPage from '../components/ScopeWitness';
import ScopeDetailsPageCalibration from '../components/ScopeWitnessCalibration';
import ScopeDetailsPageTesting from '../components/ScopeWitnessTesting';
import NCReply from '../components/NCReply';
import LaboratoryNCReply from '../pages/Laboratory/AssessmentReport/LaboratoryNCReply';
import NCApplicationFinding from '../components/AssessmentReport/NCApplicationFinding';
import Form217Report from '../components/AssessmentReport/Form217Report';
import NCMainReport from '../components/AssessmentReport/NCMainReport';
import Form8 from '../components/Form8';
import Form9 from '../components/Form9';
import LaboratorySearch from '../components/LaboratorySearch';
import IlacReport from '../components/IlacReport';
import ConvenerLayout from '../pages/Convener/layout';
import CEOLayout from '../pages/CEO/layout';
import AssessorDetailsViewCEO from '../pages/CEO/application/AssessorDetailsView';
import DirectorLayout from '../pages/Director/layout';
import AssessorDetailsViewDirector from '../pages/Director/application/AssessorDetailsView';
import Form72Report from '../components/Form72';
import RegistrationPage_temp from '../components/RegistrationPage_temp';
import RegistrationPage_old from '../components/RegistrationPage_old';
import RegistrationPage_ppp_ffl from '../components/RegistrationPage_ppp_ffl';
import Advisory from '../pages/Do/AC_Process/Advisory';
import ComplaintLayout from '../pages/Complaint/layout';
import UnpaidAssessmentProformaInvoice from '../pages/Accounts/invoice/UnpaidAssessmentProformaInvoice'
import OutstandingAmount from '../pages/OutstandingAmount/OutstandingAmount'
import Ledger from '../pages/OutstandingAmount/Ledger'
import OutstandingLedgerLab from '../pages/OutstandingAmount/OutstandingLedger'
import OutstandingPaymentResponse from '../pages/OutstandingAmount/OutstandingPaymentResponse'
import OutstandingLedgerStandalone from '../pages/Do/OutstandingLedgerStandalone'
import Form73Calibration from '../components/Form73Calibration';
import AssessorSearchManagement from '../components/AssessorSearch/AssessorSearchManagement';
import AssessorSearchProfile from '../components/AssessorSearch/AssessorSearchProfile';
import UpfrontFees from '../pages/UpfrontFees/UpfrontFees';
import UpfrontPaymentResponse from '../pages/UpfrontFees/UpfrontPaymentResponse';
import NablSupportDashboard from '../pages/NablSupport/Dashboard';

import MedicalLayoutPPPFFL from '../pages/Medical-PPP-FFL/layout';
import MedicalPPPFFLPaymentPage from '../pages/Medical-PPP-FFL/PaymentPage';
import MedicalPPPFFLPaymentResponsePage from '../pages/Medical-PPP-FFL/PaymentResponsePage';
import CertificateCellLayout from '../pages/CertificateCell/layout';


const AppRouter = () => {
  return (
    <Routes basename="/" >
      <Route path="/main/" element={<HomePage />} />
      <Route path="/main/login" element={<LoginPage />} />
      <Route path="/main/register" element={<RegistrationPage />} />
      <Route path="/main/register-temp" element={<RegistrationPage_temp />} />
      <Route path="/main/register-old" element={<RegistrationPage_old />} />
      <Route path="/main/register-ppp-ffl" element={<RegistrationPage_ppp_ffl />} />
      <Route path="/main/change-password" element={<ChangePasswordPage />} />
      <Route path="/main/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/main/reset-password" element={<ResetPasswordPage />} />
      <Route path="/main/location" element={<LocationPage />} />
      <Route path="/main/corruption-declaration" element={<CorruptionDeclarationPage />} />
      <Route path="/main/termsandconditions" element={<TermsConditions />} />
      <Route path="/main/termsandConditionsview" element={<TermsConditionsView />} />
      <Route path="/main/declaration" element={<CorruptionDeclarationPage />} />

      <Route path="/main/viewCertificate" element={<ViewCertificate />} />
      <Route path="/main/downloadSymbol" element={<DownloadSymbol />} />
      <Route path="/main/ilac-mark-download" element={<ILACMarkDownload />} />
      <Route path="/main/ac-process" element={<ACProcess />} />
      <Route path="/main/advisory" element={<Advisory />} />
      <Route path="/main/view-scope-master" element={<ScopeMasterPage />} />
      <Route path="/main/view-equipment-master" element={<EquipmentMasterPage />} />
      <Route path="/main/assessor-search" element={<AssessorSearchManagement />} />
      <Route path="/main/assessor-search-profile" element={<AssessorSearchProfile />} />

      {/* Dashboard route - checks stage and redirects accordingly */}
      <Route path="/main/dashboard" element={<DashboardRouteHandler />} />

      {/* Choose Assessment Date route */}
      <Route path="/main/choose-assessment-date" element={<ChooseAssessmentDate />} />

      {/* Assessment Details route */}
      <Route path="/main/assessment-details" element={<AssessmentDetailsPage />} />

      {/* Laboratory Update Details route */}
      <Route path="/main/laboratory-update-details" element={<LaboratoryUpdateDetailsPage />} />
      <Route path="/main/laboratory/feedback" element={<Feedback />} />
      <Route path="/main/laboratory/scope-witness" element={<ScopeDetailsPage />} />
      <Route path="/main/laboratory/scope-witness-calibration" element={<ScopeDetailsPageCalibration />} />
      <Route path="/main/laboratory/scope-witness-testing" element={<ScopeDetailsPageTesting />} />
      <Route path="/main/laboratory/nc-reply" element={<NCReply />} />
      <Route path="/main/laboratoryNC/nc-reply" element={<LaboratoryNCReply />} />
      <Route path="/main/laboratory/form217-preview" element={<Form217Report />} />
      <Route path="/main/laboratory/nc-report" element={<NCMainReport />} />
      <Route path="/main/laboratory/nc-application-finding" element={<NCApplicationFinding />} />
      <Route path="/main/laboratory/form8" element={<Form8/>} />
      <Route path="/main/laboratory/form9" element={<Form9/>} />
      <Route path="/main/laboratory/advisory" element={<LabAdvisoryReply />} />
      <Route path="/main/laboratory/showcause" element={<LabShowCauseReply />} />
      <Route path="/main/laboratory/form73-calibration" element={<Form73Calibration />} />

      {/* Common Laboratory Search - accessible from all sections */}
      <Route path="/main/laboratory-search" element={<LaboratorySearch />} />
      <Route path="/main/ilacReport" element={<IlacReport />} />


      <Route path="/main/assessor-profile" element={<AssessorProfilePage />} />
      <Route path="/main/view-NAF6" element={<ViewNAF6 />} />

      {/* CAB Acceptance route */}
      <Route path="/main/cab-accept-assessors" element={<AcceptAssessors />} />
      <Route path="/main/assessor-logistics-agreement" element={<AssessorLogisticsAgreement />} />

      {/* Authentication test page */}
      <Route path="/main/auth-info" element={<AuthInfo />} />
      <Route path="/main/auth-debug" element={<AuthDebug />} />

      {/* Generic application form (fallback) */}
      <Route path="/main/application-form" element={<ApplicationFormPage />} />
      {/* Testing Laboratory Application with Layout */}
      <Route path="/main/testing" element={<TestingLayout />} />
      <Route path="/main/testing/laboratory-details" element={<TestingLayout />} />
      <Route path="/main/testing/laboratory-detailsAssessment" element={<TestingLayout />} />
      <Route path="/main/testing/organizationAssessment" element={<TestingLayout />} />
      <Route path="/main/testing/organization" element={<TestingLayout />} />
      <Route path="/main/testing/proficiency-testing" element={<TestingLayout />} />
      <Route path="/main/testing/discipline" element={<TestingLayout />} />
      <Route path="/main/testing/disciplineAssessment" element={<TestingLayout />} />
      <Route path="/main/testing/scope" element={<TestingLayout />} />
      <Route path="/main/testing/scopeAssessment" element={<TestingLayout />} />
      <Route path="/main/testing/fees" element={<TestingLayout />} />
      <Route path="/main/testing/lab-staff" element={<TestingLayout />} />
      <Route path="/main/testing/lab-staffAssessment" element={<TestingLayout />} />
      <Route path="/main/testing/sub-user" element={<TestingLayout />} />
      <Route path="/main/testing/equipment" element={<TestingLayout />} />
      <Route path="/main/testing/reference-material" element={<TestingLayout />} />
      <Route path="/main/testing/infrastructure" element={<TestingLayout />} />
      <Route path="/main/testing/documentation" element={<TestingLayout />} />
      <Route path="/main/testing/enclosure" element={<TestingLayout />} />
      <Route path="/main/testing/declaration" element={<TestingLayout />} />
      <Route path="/main/testing/phantoms" element={<TestingLayout />} />
      <Route path="/main/testing/radioisotopes" element={<TestingLayout />} />
      <Route path="/main/testing/final-submit" element={<TestingLayout />} />
      <Route path="/main/testing/final-assessor-submit" element={<TestingLayout />} />
      <Route path="/main/testing/payment" element={<TestingPaymentPage />} />
      <Route path="/main/testing/user-manual-viewer" element={<MedicalPDFViewer />} />
      <Route path="/main/testing/non-analytical-instruments" element={<TestingLayout />} />
      <Route path="/main/testing-preview-report" element={<TestingPreviewReport />} />

      <Route path="/main/application-form" element={<ApplicationFormPage />} />
      {/* calibration Laboratory Application with Layout */}
      <Route path="/main/calibration" element={<CalibrationLayout />} />
      <Route path="/main/calibration/laboratory-details" element={<CalibrationLayout />} />
      <Route path="/main/calibration/laboratory-detailsAssessment" element={<CalibrationLayout />} />
      <Route path="/main/calibration/organizationAssessment" element={<CalibrationLayout />} />
      <Route path="/main/calibration/organization" element={<CalibrationLayout />} />
      <Route path="/main/calibration/proficiency-testing" element={<CalibrationLayout />} />
      <Route path="/main/calibration/discipline" element={<CalibrationLayout />} />
      <Route path="/main/calibration/disciplineAssessment" element={<CalibrationLayout />} />
      <Route path="/main/calibration/scope" element={<CalibrationLayout />} />
      <Route path="/main/calibration/scopeAssessment" element={<CalibrationLayout />} />
      <Route path="/main/calibration/fees" element={<CalibrationLayout />} />
      <Route path="/main/calibration/lab-staff" element={<CalibrationLayout />} />
      <Route path="/main/calibration/lab-staffAssessment" element={<CalibrationLayout />} />
      <Route path="/main/calibration/sub-user" element={<CalibrationLayout />} />
      <Route path="/main/calibration/equipment" element={<CalibrationLayout />} />
      <Route path="/main/calibration/reference-material" element={<CalibrationLayout />} />
      <Route path="/main/calibration/infrastructure" element={<CalibrationLayout />} />
      <Route path="/main/calibration/documentation" element={<CalibrationLayout />} />
      <Route path="/main/calibration/enclosure" element={<CalibrationLayout />} />
      <Route path="/main/calibration/declaration" element={<CalibrationLayout />} />
      <Route path="/main/calibration/phantoms" element={<CalibrationLayout />} />
      <Route path="/main/calibration/radioisotopes" element={<CalibrationLayout />} />
      <Route path="/main/calibration/final-submit" element={<CalibrationLayout />} />
      <Route path="/main/calibration/final-assessor-submit" element={<CalibrationLayout />} />
      <Route path="/main/calibration/payment" element={<CalibrationPaymentPage />} />
      <Route path="/main/calibration/user-manual-viewer" element={<MedicalPDFViewer />} />
      <Route path="/main/calibration/non-analytical-instruments" element={<CalibrationLayout />} />
      <Route path="/main/calibration-preview-report" element={<CalibrationPreviewReport />} />


      {/* Medical Laboratory Application with Layout */}
      <Route path="/main/medical" element={<MedicalLayout />} />
      <Route path="/main/medical/laboratory-details" element={<MedicalLayout />} />
      <Route path="/main/medical/laboratory-detailsAssessment" element={<MedicalLayout />} />
      <Route path="/main/medical/organizationAssessment" element={<MedicalLayout />} />
      <Route path="/main/medical/organization" element={<MedicalLayout />} />
      <Route path="/main/medical/proficiency-testing" element={<MedicalLayout />} />
      <Route path="/main/medical/discipline" element={<MedicalLayout />} />
      <Route path="/main/medical/disciplineAssessment" element={<MedicalLayout />} />
      <Route path="/main/medical/scope" element={<MedicalLayout />} />
      <Route path="/main/medical/scopeAssessment" element={<MedicalLayout />} />
      <Route path="/main/medical/fees" element={<MedicalLayout />} />
      <Route path="/main/medical/lab-staff" element={<MedicalLayout />} />
      <Route path="/main/medical/lab-staff-additional" element={<MedicalLayout />} />
      <Route path="/main/medical/lab-staffAssessment" element={<MedicalLayout />} />
      <Route path="/main/medical/sub-user" element={<MedicalLayout />} />
      <Route path="/main/medical/equipment" element={<MedicalLayout />} />
      <Route path="/main/medical/reference-material" element={<MedicalLayout />} />
      <Route path="/main/medical/infrastructure" element={<MedicalLayout />} />
      <Route path="/main/medical/documentation" element={<MedicalLayout />} />
      <Route path="/main/medical/enclosure" element={<MedicalLayout />} />
      <Route path="/main/medical/declaration" element={<MedicalLayout />} />
      <Route path="/main/medical/declaration-additional" element={<MedicalLayout />} />
      <Route path="/main/medical/phantoms" element={<MedicalLayout />} />
      <Route path="/main/medical/radioisotopes" element={<MedicalLayout />} />
      <Route path="/main/medical/final-submit" element={<MedicalLayout />} />
      <Route path="/main/medical/final-assessor-submit" element={<MedicalLayout />} />
      <Route path="/main/medical/payment" element={<PaymentPage />} />
      <Route path="/main/medical/user-manual-viewer" element={<MedicalPDFViewer />} />
      <Route path="/main/medical/non-analytical-instruments" element={<MedicalLayout />} />
      <Route path="/main/medical/final-submit-additional" element={<MedicalLayout />} />
      <Route path="/main/medical/add-scope-based-on-product" element={<MedicalLayout />} />
      <Route path="/main/payment/response" element={<PaymentResponsePage />} />
      <Route path="/main/paymentresponse" element={<PaymentResponsePage />} />

      {/* Medical Laboratory Public Private Partnership / Franchiser-Franchisee Application with Layout */}
      <Route path="/main/medical-ppp-ffl" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/laboratory-details" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/laboratory-detailsAssessment" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/organizationAssessment" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/organization" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/proficiency-testing" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/discipline" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/disciplineAssessment" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/scope" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/scopeAssessment" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/fees" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/lab-staff" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/lab-staff-additional" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/lab-staffAssessment" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/sub-user" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/equipment" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/reference-material" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/infrastructure" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/documentation" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/enclosure" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/declaration" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/declaration-additional" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/phantoms" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/radioisotopes" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/final-submit" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/final-assessor-submit" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/payment" element={<MedicalPPPFFLPaymentPage />} />
      <Route path="/main/medical-ppp-ffl/user-manual-viewer" element={<MedicalPDFViewer />} />
      <Route path="/main/medical-ppp-ffl/non-analytical-instruments" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/medical-ppp-ffl/final-submit-additional" element={<MedicalLayoutPPPFFL />} />
      <Route path="/main/payment/response" element={<MedicalPPPFFLPaymentResponsePage />} />
      <Route path="/main/paymentresponse" element={<MedicalPPPFFLPaymentResponsePage />} />

      {/* Assessment Payment Routes */}
      <Route path="/main/assessment-fees-payment" element={<AssessmentPaymentPage />} />
      <Route path="/main/upfront-fees" element={<UpfrontFees />} />
      <Route path="/main/upfront-payment-response" element={<UpfrontPaymentResponse />} />
      <Route path="/main/assessment/payment/response" element={<AssessmentPaymentResponsePage />} />
      <Route path="/main/assessment-payment-response" element={<AssessmentPaymentResponsePage />} />
      <Route path="/main/preview-report" element={<PreviewReport />} />
      <Route path="/main/preview-report-additional" element={<PreviewReportAdditional />} />
      <Route path="/main/preview-report-ppp-ffl" element={<PreviewReportPPPFFL />} />
      <Route path="/main/assessment-report" element={<PreviewReportassessment />} />
      <Route path="/main/assessment-report-calibration" element={<PreviewReportAssessmentCalibration />} />
      <Route path="/main/assessment-report-testing" element={<PreviewReportAssessmentTesting />} />
      <Route path="/main/preview-report7t" element={<PreviewReport7t />} />
      <Route path="/main/form72" element={<Form72Report />} />
      <Route path="/main/nabl-support/dashboard" element={<NablSupportDashboard />} />
      <Route path="/main/do/dashboard" element={<DoLayout />} />
      <Route path="/main/do/applications/history" element={<DoLayout />} />
      <Route path="/main/do/assessor-allotment" element={<DoLayout />} />
      <Route path="/main/do/parameter-allotment" element={<DoLayout />} />
      <Route path="/main/do/applications/view" element={<DoLayout />} />
      <Route path="/main/do/momcompository" element={<DoLayout />} />
      <Route path="/main/do/doallotment" element={<DoLayout />} />
      <Route path="/main/do/applications/appdashboard" element={<DoLayout />} />
      <Route path="/main/do/facility-location-approval" element={<DoLayout />} />
      <Route path="/main/do/audit-trail" element={<DoLayout />} />
      <Route path="/main/do/unfreezeApplication" element={<DoLayout />} />
      <Route path="/main/do/collection-center" element={<DoLayout />} />
      <Route path="/main/do/accounts-details" element={<DoLayout />} />
      <Route path="/main/do/form217-preview" element={<DoLayout />} />
      <Route path="/main/do/FormTestWitness" element={<DoLayout />} />
      <Route path="/main/do/nc-report" element={<DoLayout />} />
      <Route path="/main/do/nc-reply" element={<DoLayout />} />
      <Route path="/main/do/nc-application" element={<DoLayout />} />
      <Route path="/main/do/form11" element={<DoLayout />} />
      <Route path="/main/do/form11-new" element={<DoLayout />} />
      <Route path="/main/do/form72" element={<DoLayout />} />
      <Route path="/main/do/form73" element={<DoLayout />} />
      <Route path="/main/do/ac-process" element={<DoLayout />} />
      <Route path="/main/do/decision-process" element={<DoLayout />} />
      <Route path="/main/do/lab-details" element={<DoLayout />} />
      <Route path="/main/do/advisory" element={<DoLayout />} />
      <Route path="/main/do/showcause" element={<DoLayout />} />
      <Route path="/main/do/TADA" element={<DoLayout />} />
      <Route path="/main/do/edit-scope-certificate" element={<DoLayout />} />
      <Route path="/main/do/form73-calibration" element={<DoLayout />} />
      <Route path="/main/do/assessment-control" element={<DoLayout />} />
      <Route path="/main/do/assessment-tracking-log" element={<DoLayout />} />
      <Route path="/main/do/outstanding-ledger" element={<DoLayout />} />
      <Route path="/main/do/testWitnessReport" element={<DoLayout />} />
      <Route path="/main/do/create-application" element={<DoLayout />} />
      <Route path="/main/do/assessor-logistics" element={<DoLayout />} />
      <Route path="/main/do/tat-overshoot" element={<DoLayout />} />

      <Route path="/main/certificate-cell/dashboard" element={<CertificateCellLayout />} />
      <Route path="/main/certificate-cell/applications" element={<CertificateCellLayout />} />
      <Route path="/main/certificate-cell/issue-certificate" element={<CertificateCellLayout />} />
      <Route path="/main/certificate-cell/certificate-history" element={<CertificateCellLayout />} />

      <Route path="/main/admin" element={<AdminLayout />} />
      <Route path="/main/admin/dashboard" element={<AdminLayout />} />
      <Route path="/main/admin/email-notification-template" element={<AdminLayout />} />
      <Route path="/main/admin/instruction-master" element={<AdminLayout />} />
      <Route path="/main/admin/category-management" element={<AdminLayout />} />
      <Route path="/main/admin/sub-category-management" element={<AdminLayout />} />
      <Route path="/main/admin/questions-management" element={<AdminLayout />} />
      <Route path="/main/admin/compliance-management" element={<AdminLayout />} />
      <Route path="/main/admin/change-cab-size" element={<AdminLayout />} />
      <Route path="/main/admin/listform-management" element={<AdminLayout />} />
      <Route path="/main/admin/ncstatements-management" element={<AdminLayout />} />
      <Route path="/main/admin/scrutiny-remarks-management" element={<AdminLayout />} />
      <Route path="/main/admin/assessor-management" element={<AdminLayout />} />
      <Route path="/main/admin/assessor-edit" element={<AdminLayout />} />
      <Route path="/main/admin/assessor-profile" element={<AdminLayout />} />
      <Route path="/main/admin/scope-master" element={<AdminLayout />} />
      <Route path="/main/admin/equipment-master" element={<AdminLayout />} />
      <Route path="/main/admin/pt-laboratory-master" element={<AdminLayout />} />
      <Route path="/main/admin/pt-other-master" element={<AdminLayout />} />
      <Route path="/main/admin/abreviation-master" element={<AdminLayout />} />
      <Route path="/main/admin/nonanalytical-master" element={<AdminLayout />} />
      <Route path="/main/admin/discipline-master" element={<AdminLayout />} />
      <Route path="/main/admin/group-master" element={<AdminLayout />} />
      <Route path="/main/admin/sub-group-master" element={<AdminLayout />} />
      <Route path="/main/admin/jddo-mapping" element={<AdminLayout />} />
      <Route path="/main/admin/assessment-control" element={<AdminLayout />} />
      <Route path="/main/admin/assessment-tracking-log" element={<AdminLayout />} />
      <Route path="/main/admin/mark-lab-status" element={<AdminLayout />} />
      <Route path="/main/admin/certificate-report" element={<AdminLayout />} />
      <Route path="/main/admin/create-application" element={<AdminLayout />} />

      <Route path="/main/view" element={<ViewLayout />} />
      <Route path="/main/view/dashboard" element={<ViewLayout />} />
      <Route path="/main/view/email-notification-template" element={<ViewLayout />} />
      <Route path="/main/view/instruction-master" element={<ViewLayout />} />
      <Route path="/main/view/category-management" element={<ViewLayout />} />
      <Route path="/main/view/sub-category-management" element={<ViewLayout />} />
      <Route path="/main/view/questions-management" element={<ViewLayout />} />
      <Route path="/main/view/compliance-management" element={<ViewLayout />} />
      <Route path="/main/view/listform-management" element={<ViewLayout />} />
      <Route path="/main/view/ncstatements-management" element={<ViewLayout />} />
      <Route path="/main/view/scrutiny-remarks-management" element={<ViewLayout />} />
      <Route path="/main/view/assessor-management" element={<ViewLayout />} />
      <Route path="/main/view/assessor-edit" element={<ViewLayout />} />
      <Route path="/main/view/assessor-profile" element={<ViewLayout />} />
      <Route path="/main/view/scope-master" element={<ViewLayout />} />
      <Route path="/main/view/equipment-master" element={<ViewLayout />} />
      <Route path="/main/view/pt-laboratory-master" element={<ViewLayout />} />
      <Route path="/main/view/pt-other-master" element={<ViewLayout />} />
      <Route path="/main/view/abreviation-master" element={<ViewLayout />} />
      <Route path="/main/view/jddo-mapping" element={<ViewLayout />} />
      <Route path="/main/view/applications/view" element={<ViewLayout />} />
      <Route path="/main/view/applications/appdashboard" element={<ViewLayout />} />


      <Route path="/main/superAdmin" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/dashboard" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/email-notification-template" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/instruction-master" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/category-management" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/sub-category-management" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/questions-management" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/compliance-management" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/listform-management" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/ncstatements-management" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/scrutiny-remarks-management" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/assessor-management" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/assessor-edit" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/assessor-profile" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/scope-master" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/equipment-master" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/pt-laboratory-master" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/pt-other-master" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/abreviation-master" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/discipline-master" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/group-master" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/sub-group-master" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/create-users" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/ac-dates" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/admin-password-reset" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/stage-update" element={<SuperAdminLayout />} />
      <Route path="/main/superAdmin/mark-lab-status" element={<SuperAdminLayout />} />

      {/* Accounts Routes */}
      <Route path="/main/accounts" element={<AccountsLayout />} />
      <Route path="/main/accounts/dashboard" element={<AccountsLayout />} />
      <Route path="/main/accounts/payment-details" element={<AccountsLayout />} />
      <Route path="/main/accounts/transaction-report" element={<AccountsLayout />} />
      <Route path="/main/accounts/invoice-management" element={<AccountsLayout />} />
      <Route path="/main/accounts/invoice" element={<AccountsLayout />} />
      <Route path="/main/accounts/approvalRequest" element={<AccountsLayout />} />
      <Route path="/main/accounts/approval-details" element={<AccountsLayout />} />
      <Route path="/main/accounts/offline-payment-details" element={<AccountsLayout />} />
      <Route path="/main/accounts/offline-payment-form" element={<AccountsLayout />} />
      <Route path="/main/accounts/unpaid-invoice" element={<AccountsLayout />} />
      <Route path="/main/unpaid-assessment-proforma-invoice" element={<UnpaidAssessmentProformaInvoice />} />
      <Route path="/main/outstanding-amount" element={<OutstandingAmount />} />
      <Route path="/main/ledger" element={<Ledger />} />
      <Route path="/main/outstanding-ledger" element={<OutstandingLedgerLab />} />
      <Route path="/main/al-outstanding-ledger" element={<OutstandingLedgerStandalone />} />
      <Route path="/main/outstanding-payment-response" element={<OutstandingPaymentResponse />} />
      <Route path="/main/accounts/proforma-invoice" element={<AccountsLayout />} />
      <Route path="/main/accounts/generated-invoice" element={<AccountsLayout />} />
      <Route path="/main/accounts/generatedaafee-invoice" element={<AccountsLayout />} />
      <Route path="/main/accounts/aafeeproforma-invoices" element={<AccountsLayout />} />
      <Route path="/main/accounts/gst-exemption" element={<AccountsLayout />} />
      <Route path="/main/accounts/sez-exemption" element={<AccountsLayout />} />
      <Route path="/main/accounts/sez-applications" element={<AccountsLayout />} />
      <Route path="/main/accounts/download" element={<AccountsLayout />} />
      <Route path="/main/accounts/aafee-invoice-generate" element={<AccountsLayout />} />
      <Route path="/main/accounts/invoice-data-pushed" element={<AccountsLayout />} />
      <Route path="/main/accounts/outstanding-ledger" element={<AccountsLayout />} />

      {/* Legacy individual routes for backward compatibility */}
      <Route path="/main/webassessment/submitDa" element={<WebAssessmentLayout />} />
      <Route path="/main/webassessment/submitDaCalibration" element={<WebAssessmentLayout />} />

      <Route path="/main/assessor/application-assessment" element={<AssessorLayout />} />
      <Route path="/main/assessor/applications" element={<AssessorLayout />} />
      <Route path="/main/assessor/applications/detail" element={<AssessorLayout />} />
      <Route path="/main/assessor/dashboard" element={<AssessorLayout />} />
      <Route path="/main/assessor/assessor-details" element={<AssessorLayout />} />
      <Route path="/main/assessor/assessor-profile" element={<AssessorLayout />} />
      <Route path="/main/assessor/assessor-bio-data" element={<AssessorLayout />} />
      <Route path="/main/assessor/assessment-dashboard" element={<AssessorLayout />} />
      <Route path="/main/assessor/checklist" element={<AssessorLayout />} />
      <Route path="/main/assessor/TADA" element={<AssessorLayout />} />
      <Route path="/main/assessor/NAF6" element={<AssessorLayout />} />
      <Route path="/main/assessor/NAF6-new" element={<AssessorLayout />} />
      <Route path="/main/assessor/test-witness" element={<AssessorLayout />} />
      <Route path="/main/assessor/equipment-details" element={<AssessorLayout />} />
      <Route path="/main/assessor/naf1" element={<AssessorLayout />} />
      <Route path="/main/assessor/feedback" element={<AssessorLayout />} />
      <Route path="/main/assessor/scope-witness" element={<AssessorLayout />} />
      <Route path="/main/assessor/form217-preview" element={<AssessorLayout />} />
      <Route path="/main/assessor/nc-reply" element={<AssessorLayout />} />
      <Route path="/main/assessor/nc-report" element={<AssessorLayout />} />
      <Route path="/main/assessor/nc-application" element={<AssessorLayout />} />
      <Route path="/main/assessor/nc-application-finding" element={<AssessorLayout />} />
      <Route path="/main/assessor/form9" element={<AssessorLayout />} />
      <Route path="/main/assessor/scope-witness-calibration" element={<AssessorLayout />} />
      <Route path="/main/assessor/scope-witness-testing" element={<AssessorLayout />} />
      <Route path="/main/assessor/form73-calibration" element={<AssessorLayout />} />
      
      {/* NAssessor specific routes */}
      <Route path="/main/assessor/assessor-nc-clarification" element={<AssessorLayout />} />
      <Route path="/main/assessor/assessor-logistic-details" element={<AssessorLayout />} />
      
      <Route path="/main/jd/applications/assessors" element={<AssessorDetailsView />} />
      
      <Route path="/main/jd/dashboard" element={<JDLayout />} />
      <Route path="/main/jd/inactive" element={<JDLayout />} />
      <Route path="/main/jd/extend" element={<JDLayout />} />
      <Route path="/main/jd/applications/view" element={<JDLayout />} />
      <Route path="/main/jd/applications/history" element={<JDLayout />} />
      <Route path="/main/jd/applications/appdashboard" element={<JDLayout />} />
      <Route path="/main/jd/application/form8" element={<JDLayout />} />
      <Route path="/main/jd/application/form9" element={<JDLayout />} />
      <Route path="/main/jd/FormTestWitness" element={<JDLayout />} />
      <Route path="/main/jd/nc-report" element={<JDLayout />} />
      <Route path="/main/jd/form72" element={<JDLayout />} />
      <Route path="/main/jd/form73" element={<JDLayout />} />
      <Route path="/main/jd/form11" element={<JDLayout />} />
      <Route path="/main/jd/form11-new" element={<JDLayout />} />
      <Route path="/main/jd/request-form11" element={<JDLayout />} />
      <Route path="/main/jd/form217-preview" element={<JDLayout />} />
      <Route path="/main/jd/nc-application" element={<JDLayout />} />
      <Route path="/main/jd/accounts-details" element={<JDLayout />} />
      <Route path="/main/jd/additional-app-dashboard" element={<JDLayout />} />
      <Route path="/main/jd/ilac-app-dashboard" element={<JDLayout />} />
      <Route path="/main/jd/outstanding-ledger" element={<JDLayout />} />
      <Route path="/main/jd/testWitnessReport" element={<JDLayout />} />
      <Route path="/main/jd/nc-reply" element={<JDLayout />} />
      <Route path="/main/jd/tat-violation" element={<JDLayout />} />
      <Route path="/main/jd/form73-calibration" element={<JDLayout />} />


      {/* Additional Documents Page */}
      <Route path="/main/application/additional-documents" element={<AdditionalDocumentsPage />} />

      {/* Assessor Management QR Code Page */}
      <Route path="/main/assessormanagement" element={<AssessorManagement />} />
      <Route path="/assessormanagement" element={<AssessorManagement />} />

        {/* Convener Dashboard and related routes */}
      <Route path="/main/convener/dashboard" element={<ConvenerLayout />} />
      <Route path="/main/convener/ac-dates" element={<ConvenerLayout />} />
      <Route path="/main/convener/upload-mom" element={<ConvenerLayout />} />
      <Route path="/main/convener/agenda-date" element={<ConvenerLayout />} />

      {/* CEO Dashboard and related routes */}     
      <Route path="/main/ceo/applications/assessors" element={<AssessorDetailsViewCEO />} /> 
      <Route path="/main/ceo/dashboard" element={<CEOLayout />} />
      <Route path="/main/ceo/applications/view" element={<CEOLayout />} />
      <Route path="/main/ceo/applications/history" element={<CEOLayout />} />
      <Route path="/main/ceo/applications/appdashboard" element={<CEOLayout />} />
      <Route path="/main/ceo/application/form8" element={<CEOLayout />} />
      <Route path="/main/ceo/application/form9" element={<CEOLayout />} />
      <Route path="/main/ceo/FormTestWitness" element={<CEOLayout />} />
      <Route path="/main/ceo/nc-report" element={<CEOLayout />} />
      <Route path="/main/ceo/form72" element={<CEOLayout />} />
      <Route path="/main/ceo/form73" element={<CEOLayout />} />
      <Route path="/main/ceo/form11" element={<CEOLayout />} />
      <Route path="/main/ceo/form217-preview" element={<CEOLayout />} />
      <Route path="/main/ceo/nc-application" element={<CEOLayout />} />
      <Route path="/main/ceo/accounts-details" element={<CEOLayout />} />
      <Route path="/main/ceo/additional-app-dashboard" element={<CEOLayout />} />
      <Route path="/main/ceo/outstanding-ledger" element={<CEOLayout />} />
      <Route path="/main/ceo/tat-violation" element={<CEOLayout />} />
      <Route path="/main/ceo/lab-flow-details" element={<CEOLayout />} />

      {/* Director Dashboard and related routes */}     
      <Route path="/main/director/applications/assessors" element={<AssessorDetailsViewDirector />} /> 
      <Route path="/main/director/dashboard" element={<DirectorLayout />} />
      <Route path="/main/director/applications/view" element={<DirectorLayout />} />
      <Route path="/main/director/applications/history" element={<DirectorLayout />} />
      <Route path="/main/director/applications/appdashboard" element={<DirectorLayout />} />
      <Route path="/main/director/application/form8" element={<DirectorLayout />} />
      <Route path="/main/director/application/form9" element={<DirectorLayout />} />
      <Route path="/main/director/FormTestWitness" element={<DirectorLayout />} />
      <Route path="/main/director/nc-report" element={<DirectorLayout />} />
      <Route path="/main/director/form72" element={<DirectorLayout />} />
      <Route path="/main/director/form73" element={<DirectorLayout />} />
      <Route path="/main/director/form11" element={<DirectorLayout />} />
      <Route path="/main/director/form217-preview" element={<DirectorLayout />} />
      <Route path="/main/director/nc-application" element={<DirectorLayout />} />
      <Route path="/main/director/accounts-details" element={<DirectorLayout />} />
      <Route path="/main/director/additional-app-dashboard" element={<DirectorLayout />} />
      <Route path="/main/director/outstanding-ledger" element={<DirectorLayout />} />
      <Route path="/main/director/tat-violation" element={<DirectorLayout />} />

      {/* Complaint Dashboard and related routes */}     
      <Route path="/main/complaint/dashboard" element={<ComplaintLayout />} />
      <Route path="/main/complaint/applications/view" element={<ComplaintLayout />} />
      <Route path="/main/complaint/applications/history" element={<ComplaintLayout />} />
      <Route path="/main/complaint/applications/appdashboard" element={<ComplaintLayout />} />  
      <Route path="/main/complaint/applications/complaint-permission" element={<ComplaintLayout />} />   
       
       {/* Add-On Application Routes */}
      <Route path="/main/add-on/change-name" element={<ChangeName />} />
      <Route path="/main/add-on/acquisition-merger" element={<AcquisitionMerger />} />  
      <Route path="/main/add-on/change-incab-permises" element={<ChangeINCabPermises />} />
      <Route path="/main/add-on/ilac" element={<ILACPage />} />
    </Routes>
  );
};

export default AppRouter;
